import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=b6b21742&scoped=true&"
import script from "./InputMask.vue?vue&type=script&lang=ts&"
export * from "./InputMask.vue?vue&type=script&lang=ts&"
import style0 from "./InputMask.vue?vue&type=style&index=0&id=b6b21742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b21742",
  null
  
)

export default component.exports